import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const PiscesHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                <div className="lp-badge lp-badge--up" data-lp-reveal><span />PISCES · LSE Private Market</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">The infrastructure<br /><span style={{ color: '#FC7785' }}>PISCES needs to work.</span></h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">Buyers need to trust seller data. Sellers need preparation to be fast and affordable. Operators need automated compliance. Diligentsia closes all three gaps — structured disclosures, AI-reviewed, director-certified.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <Link className="lp-btn lp-btn--primary" to={ROUTES.REGISTER}>Start your eligibility check</Link>
                    <a className="lp-btn lp-btn--ghost" href="#how-it-works">See how it works</a>
                </div>
                <p className="lp-hero-note" data-lp-reveal data-lp-delay="240">We can introduce you to platform operators</p>
                <div className="df jcc aic mt1rem">
                    <img className="w150px h50px mr1rem" src={require('../../../../images/landing-pages/PISCES/vestd_logo.png')} alt="PISCES private market" />
                    <img className="w130px h70px" src={require('../../../../images/landing-pages/PISCES/jp_jenkins_logo.jpg')} alt="PISCES private market" />
                </div>
            </div>

            <div className="lp-hero-art">
                <div className="lp-acc-stage">
                    <img className="lp-acc-photo" src={require('../../../../images/landing-pages/PISCES/pisces-top-banner.png')} alt="PISCES private market" />
                </div>
            </div>
        </div>
    </section>
);

export default PiscesHeroSection;
